import { postWithAuth } from '@/lib/httpAdapter';
import apiUrl from './api';

const endpoint = apiUrl + 'getTrialStatus/';

interface TrialStatusResponse {
  IsInTrial: boolean;
  IsPaidUser: boolean;
  TrialStartDate?: string;
  TrialEndDate?: string;
  DaysRemaining?: number;
  Error?: string;
}

export const getTrialStatus = async (
  userUUID: string
): Promise<TrialStatusResponse> => {
  try {
    const response = await postWithAuth(endpoint, {
      UserUUID: userUUID,
    });

    if (!response.ok) {
      const errorText = await response.json();
      console.error('Trial status response not ok:', {
        status: response.status,
        statusText: response.statusText,
        errorText,
      });
      throw new Error(
        `Failed to fetch trial status: ${response.status} ${response.statusText}`
      );
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching trial status:', error);
    throw error;
  }
};
